// extracted by mini-css-extract-plugin
export default {"addCardFooter":"AddItem_addCardFooter__eIqjW","titleForItemField":"AddItem_titleForItemField__rWm-U","addCardBtn":"AddItem_addCardBtn__9qOZS","closeIcon":"AddItem_closeIcon__3930A"};